import React, { useEffect, useState } from "react";
import { Box, Button, Card, CircularProgress, IconButton, Typography } from "@mui/material";
import { orDestCard } from "../style";
import { TripStop } from "../../../types/api";
import { useTranslation } from "react-i18next";
import downloadIcon from "../../../assets/images/icons/downloadred.svg";
import positionIcon from "../../../assets/images/icons/subtract.svg";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";
import MapViewFullScreen from "../../../components/mapViewFullScreen/MapViewFullScreen";
import { useTripContext } from "../../../context/tripsContext";
import { useTripDocument } from "../../../context/TripDocumentContext";
import { LegacyCode } from "../../../types/profile";
import { User } from "../../../types/auth";

interface OriginDestiCardProps {
  tripEndpoints: TripStop[];
  handleOpenDialog?: () => void;
  tripId: number;
  legacyData: LegacyCode[];
  user:User;
}

const OriginDestiCard: React.FC<OriginDestiCardProps> = ({
  tripEndpoints,
  handleOpenDialog,
  tripId,
  legacyData,
  user
}) => {
  const [origin, destination] = tripEndpoints;
  const { t, i18n } = useTranslation();
  const windowWidth = useWindowSize();
  const isMobile = windowWidth < 1226;
  const [openMap, setOpenMap] = useState(false);
  const {
    tripDetails,
    fetchAllPosition,
    allPosition,
  } = useTripContext();
  const { generatePDF } = useTripDocument();
  const [loader,setLoader] = useState<boolean>(false)
  const handleGeneratePDF = async () => {
    setLoader(true)
    const currentLanguage = i18n.language;
    const formattedLanguage =
      currentLanguage === "it"
        ? "IT"
        : currentLanguage === "en"
        ? "ENG"
        : currentLanguage;
    try {
      const pdfUrl = await generatePDF(
        tripId,
        legacyData[0].legacycode,
        formattedLanguage,
        user.contactId,
        user.accountId,
        legacyData[0].company,
      );

      // Crea un link per il download e simulando un click per scaricarlo
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'DocumentTransport.pdf';  // Imposta un nome per il file
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Rimuovi il link dal DOM
    } catch (error) {
      setLoader(false)
      console.error("Error downloading PDF:", error);
    }
    setLoader(false);
  };

  // Effettua la chiamata per ottenere i dati di aggiornamento
  useEffect(() => {
    if (tripDetails && allPosition === null) {
      // Estrarre i valori da tmsKey
      const [erpSystem, erpCompany, orderType, orderNumber] =
        tripDetails.tmsKey.split("_");

      const data = {
        erpSystem,
        erpCompany: Number(erpCompany),
        orderType: Number(orderType),
        orderNumber,
      };
      fetchAllPosition(data);
    }
  }, [tripDetails, allPosition, fetchAllPosition]);

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  return (
    <Card sx={isMobile ? orDestCard.cardM : orDestCard.cardD}>
      <Box sx={orDestCard.mainWrapper}>
        <Box sx={isMobile ? orDestCard.wrapperM : orDestCard.wrapperD}>
          <Box sx={isMobile ? orDestCard.box1M : orDestCard.box1D}>
            <Typography sx={orDestCard.title}>
              {" "}
              {t("screens.trips.oriDest.origin")}
            </Typography>
            <Typography sx={orDestCard.subtitle}>
              {origin.invPartyName ? origin.invPartyName : "-"}
            </Typography>
            <Typography sx={orDestCard.value}>{origin.address}</Typography>
          </Box>
          <Box sx={isMobile ? orDestCard.box1M : orDestCard.box1D}>
            <Typography sx={orDestCard.title}>
              {" "}
              {t("screens.trips.oriDest.destination")}
            </Typography>
            <Typography sx={orDestCard.subtitle}>
              {destination.invPartyName ? destination.invPartyName : "-"}
            </Typography>
            <Typography sx={orDestCard.value}>{destination.address}</Typography>
          </Box>
        </Box>
       {/*  {!loader?   <Button
          startIcon={
            <img
              src={downloadIcon}
              alt="documents download Icon"
              style={orDestCard.icon}
            />
          }
          variant="text"
          fullWidth={isMobile ? true : false}
          sx={orDestCard.button}
          onClick={handleGeneratePDF}
        >
         {t("screens.trips.oriDest.downloadTransportDocument")}
        </Button> :<Box sx={{width:'25%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'8px'}}><CircularProgress/></Box>} */}
     
      </Box>
      {!isMobile ? (
        <IconButton
          sx={orDestCard.iconButton}
          onClick={() => {
            setOpenMap(true);
          }}
        >
          <img src={positionIcon} alt="Position Icon" style={orDestCard.icon} />
        </IconButton>
      ) : (
        <Box sx={orDestCard.mobileWrapper}>
          <Button fullWidth variant="contained" onClick={() => {
            setOpenMap(true);
          }}>
          { t("screens.trips.mobileCard.tripMap")}
          </Button>
          <Button fullWidth variant="contained" onClick={handleOpenDialog}>
          { t("screens.trips.mobileCard.tripTimeline")}
          </Button>
        </Box>
      )}

      {openMap && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-80 z-[99998]" />

          <MapViewFullScreen
            visible={openMap}
            fullScreenHandler={handleCloseMap}
            positions={allPosition?.positionsList || []}
          />
        </>
      )}
    </Card>
  );
};

export default OriginDestiCard;
